import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { FlexWrapper } from 'lib/ui'
import { ReactComponent as LogoSvg } from 'resources/svg/logo.svg'
import LogoLivBrite from 'app/livbrite/resources/images/livBrite_logo.png'
import { useStoreView } from 'hooks/useStoreView'
import { ReactComponent as CloseSvg } from 'resources/svg/icons/close-thin.svg'
import { ReactComponent as ReloadSvg } from 'resources/svg/icons/reload.svg'
import { Wrapper, Logo } from './styled'

export const ProductSelectorHeader = () => {
  const { isSofiaAndGrace } = useStoreView()
  const history = useHistory()
  const { pathname } = useLocation()

  const handleReload = () => {
    const isResults = pathname.includes('product-selector/results')

    if (isResults) {
      history.push('/product-selector/questions')
    } else {
      window.location.reload(false)
    }
  }

  return (
    <Wrapper>
      <FlexWrapper kind='between' verticalCenter className='wrapper'>
        <div onClick={() => history.push('/')}>
          <CloseSvg />
        </div>
        <Logo>
          <Link to='/'>
            {isSofiaAndGrace ? (
              <LogoSvg />
            ) : (
              <img src={LogoLivBrite} alt='LivBrite' />
            )}
          </Link>
        </Logo>
        <div onClick={handleReload}>
          <ReloadSvg />
        </div>
      </FlexWrapper>
    </Wrapper>
  )
}
